import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UserCombi } from "../../../../model";
import { UserCombiFromToModule } from "../usercombi-from-to/usercombi-from-to-modal.module";
import { TranslateDirective } from "@ngx-translate/core";

@Component({
  selector: 'app-icon-dropdown-item-usercombi',
  templateUrl: './icon-dropdown-item-usercombi.component.html',
  styleUrls: ['./icon-dropdown-item-usercombi.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserCombiFromToModule, TranslateDirective],
  standalone: true
})
export class IconDropdownItemUsercombiComponent {
  @Input({required: true}) userCombi: UserCombi;
}
